import React from 'react';
import { TruckIcon, HomeIcon } from 'lucide-react';
const Services = () => {
  return <section id="teenused" className="py-16 bg-white" data-id="element-328">
      <div className="container mx-auto px-4" data-id="element-329">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900" data-id="element-330">
          Meie teenused
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-331">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300" data-id="element-332">
            <div className="bg-blue-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-333">
              <div size={24} className="text-white" data-id="element-334" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-335">
              Mööbli montaaž
            </h3>
            <p className="text-gray-700" data-id="element-336">
              Pakume professionaalset mööbli kokkupanemise teenust. Monteerime
              kokku kõik tüüpi mööblit, alates lihtsamatest riiulitest kuni
              keerulisemate köögimööbliteni.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300" data-id="element-337">
            <div className="bg-blue-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-338">
              <HomeIcon size={24} className="text-white" data-id="element-339" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-340">
              Mööbli paigaldus
            </h3>
            <p className="text-gray-700" data-id="element-341">
              Paigaldame kokkupandud mööbli ohutult ja korrektselt. Kinnitame
              kapid seina külge, reguleerime uksed ja sahtlid ning tagame, et
              kõik oleks loodis.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300" data-id="element-342">
            <div className="bg-blue-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-343">
              <TruckIcon size={24} className="text-white" data-id="element-344" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-345">
              Teenindame üle Eesti
            </h3>
            <p className="text-gray-700" data-id="element-346">
              Pakume teenuseid peamiselt Viljandimaal, kuid liigume vajadusel
              üle kogu Eesti. Võta meiega ühendust ja leiame lahenduse sinu
              mööbliprobleemidele.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Services;